export default {
    namespaced: true,
    state() {
        return {
            userPresenceLists: [],
        }
    },
    getters: {
        usersPresence: state => state.userPresenceLists,
        getUserPresence: (state) => (userId) => {
            let userPresence = null

            state.userPresenceLists.forEach(group => {
                Object.values(group.users).forEach(user => {
                    if (user.id === userId) {
                        userPresence = user;
                    }
                })
            })

            return userPresence
        }
    },
    mutations: {
        SET_USERS_PRESENCE(state, payload) {
            state.userPresenceLists = payload
        }
    },
    actions: {
        setUsersPresence({commit}, userPresence) {
            commit('SET_USERS_PRESENCE', userPresence)
        },
        updateUsersPresence({commit, state}, data) {
            let userKey = null
            let userToMove = null
            let presence = state.userPresenceLists
            let targetStatus = null

            presence.forEach(group => {
                for (let key in group.users) {
                    if (group.users[key].id === data.user_id) {
                        userKey = key
                        userToMove = group.users[key]

                        delete group.users[key]; // Remove the user
                        break;
                    }
                }
            })

            if (data.status === 'busy') {
                targetStatus = presence.find(group => group.label === data.name)
            } else {
                targetStatus = presence.find(group => group.status === data.status)
            }

            if (targetStatus && userKey && userToMove) {
                const newUser = {}

                userToMove.css = data.css
                userToMove.status = data.status
                userToMove.status_label = data.name

                newUser[userKey] = userToMove

                targetStatus.users = {...newUser, ...targetStatus.users}
            }

            commit('SET_USERS_PRESENCE', presence)
        }
    }
}